export enum BootstrapBreakpoint {
    none = "NONE",
    xs = "XS",
    sm = "SM",
    md = "MD",
    lg = "LG",
    xl = "XL",
    xxl = "XXL"
}